<ng-container #metadataSelectorContainer/>
<ng-container #dataLoaderContainer/>
<ng-container #rowSelectorContainer/>
<ng-container #gridInitializerContainer/>
<ng-container #orderingContainer/>
<ng-container #contentRendererContainer/>
<ng-container #noDataRendererContainer/>
<ng-container #pagingContainer/>